import { IconButton, Heading, Steps, Text, Button, HStack, VStack } from '@genial/components';
import { Spacing, Color, Typography } from '@genial/design-tokens';
import React from 'react';

import { useFooter, useHeader } from '../../hooks';

interface HeaderProps {
  handleCancelButton?: () => void;
  cancelButtonIsDisabled?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ cancelButtonIsDisabled, handleCancelButton }) => {
  const { currentStep, totalSteps, stepTitle, handleGoBack, isMobile } = useHeader();
  const { handleCancelOrder, cancelOrderIsDisabled } = useFooter();

  const cancelButtonDisabled = cancelButtonIsDisabled ?? cancelOrderIsDisabled;
  const onPressCancelButton = handleCancelButton ?? handleCancelOrder;

  if (isMobile) {
    return (
      <VStack pt={Spacing['inline.xxs']} space={Spacing['inset.xs']}>
        <HStack alignItems="center" justifyContent={'space-between'}>
          <HStack alignItems="center" space={Spacing['inline.xxxs']}>
            <IconButton
              testId="icon"
              icon="ArrowLeft"
              iconSize="xxs"
              p={0}
              backgroundColor="transparent"
              iconColor={Color['brand.primary.principal']}
              onPress={handleGoBack}
            />
            <Text variant="bold" fontSize={Typography['fontsize.lg']} color="neutral.black">
              Nova boleta
            </Text>
          </HStack>
          <Button
            variant="textLink"
            isDisabled={cancelButtonDisabled}
            onPress={onPressCancelButton}
            _text={{
              color: 'feedback.error.default',
              fontWeight: Typography['fontweight.semibold'],
            }}>
            Cancelar
          </Button>
        </HStack>
        <Steps testId="qa" currentStep={currentStep} totalSteps={totalSteps} title={stepTitle} />
      </VStack>
    );
  }

  return (
    <HStack pt={Spacing['inset.lg']} alignItems="center" justifyContent="space-between">
      <HStack alignItems="center" space={Spacing['inline.xxxs']}>
        <IconButton
          icon="ArrowLeft"
          testId="return-button"
          shadow={3}
          variant="link"
          onPress={handleGoBack}
          iconColor={Color['brand.tertiary.principal']}
          iconSize="xs"
        />
        <Heading testId="qa" size="h2">
          Nova boleta
        </Heading>
      </HStack>
      <Steps testId="qa" currentStep={currentStep} totalSteps={totalSteps} />
    </HStack>
  );
};
